module.exports = __webpack_public_path__ + "static/media/bed-bunk.ff8aa8e2.svg";